import React from 'react'
import PropTypes from 'prop-types'
import WidgetWithSections from '../WidgetWithSections'
import WidgetContainer from '../../containers/WidgetContainer'
import SectionsMenu from '../../utils/SectionsMenu'
import DiscountsContainer from './DiscountsContainer'

class DailyDiscounts extends WidgetWithSections {
  render () {
    const {
      activeSection,
      boxes,
      sections
    } = this.state

    const {
      widget,
      widget: {
        utmMedium,
        utmSource
      },
      googleAnalytics
    } = this.props

    const utmParams = {
      utmSource,
      utmMedium
    }

    const activeBoxes = boxes[activeSection]

    const headlineContent = <SectionsMenu
      activeSection={activeSection}
      onSectionClick={this.handleSectionClick}
      sections={sections}
    />

    return (
      <WidgetContainer widget={widget} headlineContent={headlineContent}>
        <DiscountsContainer boxes={activeBoxes} utmParams={utmParams} googleAnalytics={googleAnalytics}/>
      </WidgetContainer>
    )
  }
}

DailyDiscounts.propTypes = {
  widget: PropTypes.object.isRequired,
  googleAnalytics: PropTypes.object
}

export default DailyDiscounts
